import Component from '@bythepixel/component-loader';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

function formatAsInt(value) {
  const onlyDigits = value.replace('$', '').replace(',', '');
  return parseInt(onlyDigits, 10);
}

export default class Range extends Component {
  static selector = '[data-comp-range]';
  static loaderPriority = 'in-view';

  constructor(element) {
    super(element);

    this.slider = this.$container.querySelector('[data-comp-range-controls]');

    this.uom = this.$container.dataset.uom;
    this.name = this.$container.dataset.compRange;

    this.rangeHandle = this.$container.querySelector('[data-range-handle]');
    this.maxInput = this.$container.querySelector('[data-range-max-input]');
    this.minValue = this.rangeHandle.min;
    this.maxValue = this.rangeHandle.max;
    this.stepValue = this.rangeHandle.step;
    this.startingValue = this.rangeHandle.value;

    this.initSlider();

    this.attachEventListenersToInput(this.maxInput);
    this.pageLoadEvents();

    window.addEventListener(`resetRange${this.name}`, () => {
      this.maxInput.value = this.formatForInput(this.startingValue);
      this.updateSliderValues();
    });
  }

  initSlider() {
    const min = Number(this.rangeHandle.min);
    const max = Number(this.rangeHandle.max);
    const stepValue = Number(this.stepValue);

    noUiSlider.create(this.slider, {
      start: [this.startingValue],
      step: stepValue,
      connect: 'lower',
      range: {
        min,
        max,
      },
    });

    this.slider.noUiSlider.on('update', (values, handle) => {
      const value = values[handle];

      this.maxInput.value = this.formatForInput(value);
      this.rangeHandle.value = formatAsInt(value);
      this.rangeHandle.dispatchEvent(new Event('input'));
    });
  }

  pageLoadEvents() {
    if (!this.minRange || !this.maxRange) {
      return;
    }

    this.maxInput.value = this.formatForInput(this.maxRange.value);
    this.updateSliderValues();
  }

  roundValue(value = 0) {
    const interval = this.stepValue;

    return interval * Math.ceil(value / interval);
  }

  updateSliderValues() {
    const valueFormatted = formatAsInt(this.maxInput.value);
    const value = parseInt(valueFormatted);
    const valueRounded = this.roundValue(value);

    const max = formatAsInt(valueRounded.toString());
    this.slider.noUiSlider.set(max);
  }

  /**
   * @param {HTMLElement} inputElement
   * @returns
   */
  attachEventListenersToInput(inputElement) {
    if (!this.maxInput || !this.rangeHandle) {
      return;
    }

    // when focus on input, clear it but don't update slider until blur
    inputElement.addEventListener('focus', () => {
      // eslint-disable-next-line
      inputElement.value = "";
    });

    inputElement.addEventListener('blur', () => {
      this.updateSliderValues();
    });

    inputElement.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        this.updateSliderValues();
      }
    });
  }

  formatForInput(value) {
    let formatted = formatAsInt(value);

    if (!this.uom) {
      return formatted;
    }

    formatted = formatted.toLocaleString('en-US');

    if (this.uom === 'usd') {
      return `$${formatted}`;
    }

    return parseInt(this.maxValue) === parseInt(value)
      ? `${formatted}+ ${this.uom}`
      : `${formatted} ${this.uom}`;
  }
}
